import { Badge, Box, Span } from '@welbe/design-system';

type StatusTypeProps = {
	[key: string]: {
		color: string;
		label: string;
		colorPalette: string;
	};
};

export const statusType: StatusTypeProps = {
	active: { label: 'Activo', color: '#8dc63f', colorPalette: 'green' },
	pendent: { label: 'Pendiente', color: '#ffd642', colorPalette: 'yellow' },
	disabled: { label: 'Desactivado', color: '#808080', colorPalette: 'gray' },
	inactive: { label: 'Desactivado', color: '#808080', colorPalette: 'gray' },
};

type StatusCellProps = {
	status?: string;
};

export const StatusCell = ({ status }: StatusCellProps) => {
	if (!status) return <Span>-</Span>;

	const current = statusType[status];

	if (!current) return <Span>-</Span>;

	return (
		<Badge
			variant="subtle"
			border="1px solid"
			size="sm"
			colorPalette={current.colorPalette}
		>
			<Box w="6px" h="6px" bg={current.color} rounded="sm" />
			<Span>{current.label}</Span>
		</Badge>
	);
};
